import { useDebounceCallback } from '@ovpn-ui/utils';
import noop from 'lodash/noop';
import { useCallback, useEffect, useState } from 'react';
export function useDropdownSearch({
  query = '',
  searchDebounceMs,
  onSearch = noop
}) {
  const [searchInputValue, setSearchInputValue] = useState(query);
  const [searchQuery, setSearchQuery] = useState(query);
  useEffect(() => {
    setSearchInputValue(query);
    setSearchQuery(query);
  }, [query]);
  const resetSearch = useCallback(() => {
    setSearchInputValue('');
    setSearchQuery('');
  }, []);
  const search = useCallback(searchValue => {
    setSearchQuery(searchValue);
    onSearch(searchValue);
  }, [onSearch]);
  const searchDebounced = useDebounceCallback(search, searchDebounceMs);
  const handleSearch = useCallback(searchValue => {
    setSearchInputValue(searchValue);
    searchDebounced == null ? void 0 : searchDebounced(searchValue);
  }, [searchDebounced]);
  return {
    searchInputValue,
    searchQuery,
    resetSearch,
    handleSearch
  };
}